import { render } from "./MedicareCardForm.vue?vue&type=template&id=6fa1fde5&scoped=true"
import script from "./MedicareCardForm.vue?vue&type=script&lang=js"
export * from "./MedicareCardForm.vue?vue&type=script&lang=js"

import "./MedicareCardForm.vue?vue&type=style&index=0&id=6fa1fde5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa1fde5"]])

export default __exports__